import React from "react";
import Autocomplete from "@mui/material/Autocomplete";
import { TextField } from "@mui/material";
import { useEffect, useState } from "react";
import { useApiClient } from "../../../api";

const LocalAuthoritySearchAutocomplete = ({ value, onChange }) => {
  const ApiClient = useApiClient();
  const [inputValue, setInputValue] = useState("");
  const [debouncedValue, setDebouncedValue] = useState("");
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pageInfo, setPageInfo] = useState({
    endCursor: null,
    hasNextPage: false,
  });

  useEffect(() => {
    const timeout = setTimeout(() => setDebouncedValue(inputValue), 200);
    return () => clearTimeout(timeout);
  }, [inputValue]);

  const loadOptions = async ({ after = null, append = false } = {}) => {
    setLoading(true);
    try {
      const result = await ApiClient.schools.searchLocalAuthorities({
        searchString: debouncedValue,
        baseSearch: true,
        first: 20,
        after,
      });
      const nextOptions = (result.edges || []).map((edge) => edge.node);
      setOptions((current) =>
        append
          ? [
              ...current,
              ...nextOptions.filter(
                (option) => !current.some(({ id }) => id === option.id),
              ),
            ]
          : nextOptions,
      );
      setPageInfo(result.pageInfo);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadOptions();
  }, [debouncedValue]);

  const loadNextPage = (event) => {
    const listbox = event.currentTarget;
    const isNearEnd =
      listbox.scrollTop + listbox.clientHeight >= listbox.scrollHeight - 8;
    if (isNearEnd && pageInfo.hasNextPage && !loading) {
      loadOptions({ after: pageInfo.endCursor, append: true });
    }
  };

  return (
    <Autocomplete
      sx={{ minWidth: { xs: "100%", sm: 280 }, flex: "1 1 280px" }}
      value={value}
      inputValue={inputValue}
      options={options}
      loading={loading}
      filterOptions={(items) => items}
      isOptionEqualToValue={(option, selected) => option.id === selected.id}
      getOptionLabel={(option) => option.name || option.code}
      onChange={(_event, nextValue) => onChange(nextValue)}
      onInputChange={(_event, nextInputValue) => setInputValue(nextInputValue)}
      ListboxProps={{ onScroll: loadNextPage }}
      renderOption={(props, option) => (
        <li {...props} key={option.id}>
          {option.name || "Not provided"} ({option.code})
        </li>
      )}
      renderInput={(params) => (
        <TextField {...params} label="Local authority" size="small" />
      )}
    />
  );
};

export default LocalAuthoritySearchAutocomplete;
